import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import App from './App';
import { Toaster } from './components/ui/sonner';

// Apply saved dark mode on load
if (localStorage.getItem('operio-theme') === 'dark') {
  document.documentElement.classList.add('dark');
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
      <Toaster position="top-right" />
    </HelmetProvider>
  </React.StrictMode>
);

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').then((registration) => {
      // Auto-detektera nya versioner. När ny SW hittats → trigga sida-omladdning
      // så användaren ser den nya appen direkt utan att behöva rensa cache manuellt.
      registration.addEventListener('updatefound', () => {
        const newWorker = registration.installing;
        if (!newWorker) return;
        newWorker.addEventListener('statechange', () => {
          if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
            // Nyare version aktiv — meddela användaren och ladda om
            newWorker.postMessage({ type: 'SKIP_WAITING' });
          }
        });
      });
      // När den nya SW:n tagit över → reload sidan (så uppdaterad UI syns)
      let refreshing = false;
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (refreshing) return;
        refreshing = true;
        window.location.reload();
      });
      // Kolla efter uppdatering var 30:e minut (bra för PWA på mobiler)
      setInterval(() => registration.update().catch(() => {}), 30 * 60 * 1000);
    }).catch(() => {});
  });
}
